<template>
    <div>
        <div class="page-title">我的帳戶 My Account</div>
        <el-card class="box-card">
              <accountFrom ref="ruleForm" :formLabelAlign="formLabelAlign" :isDetail="true"></accountFrom>
              <el-button type="info" @click="onSubmit">提交 Submit</el-button>
        </el-card>
        <div class="copyright-card">
            <copyrightCard></copyrightCard>
        </div>
    </div>
</template>

<script>
    import { getUserInfo } from "@/utils/auth";
    import {getUser,editUser} from '@/api/parent/user'
    import copyrightCard from '@/components/copyrightCard'
    import accountFrom from './components/accountFrom'
    export default {
        components: { copyrightCard,accountFrom },
        data() {
            return {
                formLabelAlign: {
                    email: '',
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                },
            }
        },
        created(){
            this.getUser()
        },
        methods:{
            onSubmit(){
                 this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.editUser()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                    });
            },
            editUser(){
                editUser(getUserInfo(`userInfo/${this.$store.getters.authorityRoute}`).userId,this.formLabelAlign).then(()=>{
                    this.$message.success('Processed successfully.')
                })
            },
            getUser(){
                getUser(getUserInfo(`userInfo/${this.$store.getters.authorityRoute}`).userId).then((v)=>{
                    this.formLabelAlign.email = v.data.email
                    this.formLabelAlign.currentPassword = v.data.password
                })
            }
        }
       
    }
</script>

<style lang="scss" scoped>
.home-title{
    color: #337AB7;
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 30px;
}
.box-card{
    margin-bottom: 30px;
    text-align: right;
}
.copyright-card{
    background-color: #fff;
}
.el-button--info {
    width: auto;
    text-align: right;
    margin-bottom: 30px;
}
</style>